import { render, staticRenderFns } from "./introduction-contact.vue?vue&type=template&id=5eda6e56&scoped=true&"
import script from "./introduction-contact.vue?vue&type=script&lang=js&"
export * from "./introduction-contact.vue?vue&type=script&lang=js&"
import style0 from "./introduction-contact.vue?vue&type=style&index=0&id=5eda6e56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda6e56",
  null
  
)

export default component.exports